import { dataLayerPush } from './dataLayerPush';

export const errorEvents = {
  handshakeError: () => dataLayerPush({ event: 'handshake_couldnot_be_created' }),
  apiError: (screen_name, error_message, error_code) => dataLayerPush({
    event: 'api_error', screen_name, error_message, error_code,
  }),
};
